// AccountSelectorModal.js
import React, { useState, useEffect } from 'react';
import { Modal, Select, Typography, Button } from 'antd';
import { ApartmentOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useAuth0 } from '@auth0/auth0-react';
import { useSharedData } from '../contexts/SharedDataContext';

const { Option } = Select;
const { Title } = Typography;

const AccountSelectorModal = ({ visible, onApply, onCancel }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [tenants, setTenants] = useState([]);
    const [selectedValue, setSelectedValue] = useState('');
    const { selectedTenant } = useSharedData();

    useEffect(() => {
        const fetchTenants = async () => {
            try {
                const token = await getAccessTokenSilently();
                const response = await axios.get('/api/authorized-tenants', {
                    headers: { Authorization: `Bearer ${token}` },
                    'x-tenant': selectedTenant,
                });
                const fetchedTenants = response.data.tenants || [];
                setTenants(fetchedTenants);
                if (fetchedTenants.length > 0) {
                    // Default to first if none already selected or if stored value is invalid.
                    if (!selectedValue || !fetchedTenants.includes(selectedValue)) {
                        setSelectedValue(fetchedTenants[0]);
                    }
                }
            } catch (err) {
                console.error('Error fetching tenants:', err);
            }
        };

        if (visible) {
            fetchTenants();
        }
    }, [getAccessTokenSilently, visible, selectedValue]);

    const handleChange = (value) => {
        setSelectedValue(value);
    };

    const handleApply = () => {
        onApply(selectedValue);
    };

    return (
        <Modal
            title="Select Account"
            visible={visible}
            onCancel={onCancel}
            footer={[
                <Button key="cancel" onClick={onCancel}>
                    Cancel
                </Button>,
                <Button key="apply" type="primary" onClick={handleApply}>
                    Apply
                </Button>,
            ]}
        >
            <div style={{ marginBottom: 16,padding: 24 }}>
                <Select value={selectedValue} style={{ width: '100%' }} onChange={handleChange}>
                    {tenants.map((tenant) => (
                        <Option key={tenant} value={tenant}>
                            <ApartmentOutlined style={{ marginRight: 8 }} />
                            {tenant}
                        </Option>
                    ))}
                </Select>
            </div>
        </Modal>
    );
};

export default AccountSelectorModal;
